module.exports = __webpack_public_path__ + "img/activities-12.955fbfe2.jpg";